<template>
  <div @keyup.enter='$emit("ready")'>
    <h2>Datos del Administrador</h2>
    <p>El usuario administardor podrá administrar el alta de nuevos usuarios para la Entidad y permisos asociados a éstos. Además podrá administrar el perfil de la Entidad (datos de la Entidad, establecimientos, etc).</p>
    <div class="wizard-form">
      <vs-input name="first_name"
                data-test="input_name"
                v-validate="'alpha_spaces|required'"
                :danger="this.errors.has('first_name')"
                :danger-text="this.errors.first('first_name')"
                size="large"
                label-placeholder="Nombre"
                v-model="firstname">
      </vs-input>
      <vs-input name="last_name"
                data-test="input_lastname"
                v-validate="'alpha_spaces|required'"
                :danger="this.errors.has('last_name')"
                :danger-text="this.errors.first('last_name')"
                size="large"
                label-placeholder="Apellido"
                v-model="lastname">
      </vs-input>
      <div class="input-btn">
        <vs-input name="email"
                   data-test="input-email2"  
                  :disabled= "verified"
                  v-validate="'required|email|validateOnDB:user,email'"
                  :danger="this.errors.has('email') ? this.errors.has('email') : !!this.emailNotVerified"
                  :danger-text="this.errors.first('email') ? this.errors.first('email') : this.emailNotVerified"
                  size="large"
                  @input="sent = false"
                  type="email"
                  icon-after="true"
                  label-placeholder="Email Corporativo"
                  v-model="email">
        </vs-input>
        <vs-button data-test="verify-email" @click="verifyBtn" :disabled="(this.errors.has('email') || email.length < 5)" :color="color()" type="filled">{{ this.verified ? 'OK' : 'Validar' }}</vs-button>
      </div>
      <vs-input name="phone"
                data-test="input-tel"
                v-validate="'required'"
                :danger="this.errors.has('phone')"
                :danger-text="this.errors.first('phone')"
                v-mask="'###-#######'"
                size="large"
                label-placeholder="Teléfono Corporativo"
                v-model="phone">
      </vs-input>
      <vs-input name="cuil"
                data-test="input-cuil"
                v-validate="'required|validateOnDB:user,cuil'"
                :danger="this.errors.has('cuil')"
                :danger-text="this.errors.first('cuil')"
                v-mask="'##-########-#'"
                size="large"
                label-placeholder="CUIL"
                v-model="cuil">
      </vs-input>
      <div class="input-group addon select-left">
        <select name="dniOrPass"
                data-test="select-doniorpass"
                @change="cleanOtherId"
                ref="dniPassSelector"
                size="large"
                v-model="dniOrPass"
                :class="{changed : !!this[dniOrPass]}">
          <option value="dni">DNI</option>
          <option value="passport">Pasaporte</option>
        </select>
        <label for="dniOrPass">Documento</label>
        <vs-input name="dni"
                  data-test="input-dni"
                  v-show="dniOrPass === 'dni' || dniOrPass ===''"
                  v-validate="'min:8|required_if:dniPassSelector,dni|validateOnDB:user,dni'"
                  :danger="this.errors.has('dni')"
                  :danger-text="this.errors.first('dni')"
                  v-mask="['#######', '########']"
                  size="large"
                  v-model="dni">
        </vs-input>
        <vs-input name="passport"
                  data-test="input-passport"
                  v-show="dniOrPass === 'passport'"
                  v-validate="'min:9|required_if:dniPassSelector,passport|validateOnDB:user,passport'"
                  :danger="this.errors.has('passport')"
                  :danger-text="this.errors.first('passport')"
                  size="large"
                  v-mask="'XXX#####X'"
                  v-model="passport">
        </vs-input>
      </div>
      <div class="input-btn tip">
        <vs-input name="password"
                  data-test="input-password"
                  v-validate="'required|min:8|validateOnDB:user,password'"
                  :danger="this.errors.has('password')"
                  danger-text="La contraseña debe respetar los lineamientos de contraseña segura."
                  type="password"
                  size="large"
                  label-placeholder="Contraseña"
                  ref="password"
                  v-model="password">
        </vs-input>
        <span class="infotip">
          <button class="infotip__host" aria-controls="infotip-overlay" aria-expanded="true" aria-label="Help" type="button">
            <vs-icon icon="help_outline"/>
          </button>
          <span class="infotip__live-region" aria-live="off">
            <div class="infotip__overlay" id="infotip-overlay">
              <!-- overlay content -->
              <div class="infotip__overlay-heading">Su contraseña debe:</div>
              <ul class="infotip__overlay-list">
                <li>Contener caracteres tanto en mayúsculas como en minúsculas (Ej. a-z, A-Z).</li>
                <li>Tener letras, dígitos y caracteres de puntuación (Ej: 0-9, !@#$%^&*()_+|~-=`{}[]:";'<>?,./ ).</li>
                <li>Tener al menos 8 caracteres de longitud.</li>
              </ul>
            </div>
          </span>
        </span>
      </div>
      <vs-input name="password_confirmation"
                data-test="input-passwordconfirm"
                v-validate="'required|confirmed:password'"
                :danger="this.errors.has('password_confirmation')"
                :danger-text="this.errors.first('password_confirmation')"
                type="password"
                size="large"
                label-placeholder="Confirmar contraseña"
                v-model="passwordConfirmation">
      </vs-input>
    </div>

    <div class='markets' v-if="!validDniCuil"> <!-- TODO: Remove class markets. -->
      <p class="validation-error-message" style='position: initial !important;'>Dni y Cuil no se corresponden.</p>
    </div>

    <vs-popup title="Ingrese su código de verificación" :active.sync="activePopup" class="email-verification">
      <img src="@/assets/images/envelope.png" alt="Email">
      <p>
        Hemos enviado un código de verificación a su correo. <br>
        Revise su cuenta e ingrese el código de 5 dígitos
      </p>
      <vs-input name="verification_code"
                data-test="input-verificaemail"
                type="number"
                size="large"
                label-placeholder="Código"
                v-model="emailNumberVerification"/>
      <p v-if="verificationErrorMsg">{{ this.verificationErrorMsg }}</p>
      <div class="vs-popup--footer">
        <vs-button data-test="button-verify" color="success" type="filled" @click="verifyEmailCode">Verificar</vs-button>
      </div>
      <div class="resend-code">
        No recibiste el código?
        <button @click="sendCode">Reenviar código</button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { Validator } from 'vee-validate'

const SendVerificationCode = gql`
  mutation generateVerificationCode($email: String!) {
    generateVerificationCode(email: $email) {
      success
      code
    }
  }
`

const VerifyCode = gql`
  mutation validateVerificationCode($code: String!, $email: String!) {
    validateVerificationCode(code: $code, email: $email) {
      success
      code
    }
  }
`

export default {
  name: 'signup-admin-data',
  methods: {
    formWithoutErrors () {
      this.validDniCuil = true
      if (this.dniOrPass == 'dni' && !this.errors.has('dni') && !this.errors.has('cuil')) {
        if (this.cuil.split('-')[1] != this.dni) {
          this.validDniCuil = false
        }
      }
      if (!this.validDniCuil) { return false }
      if (this.verified) {
        return this.$validator.validate()
      } else {
        this.emailNotVerified = 'Debe verificar su correo'
        this.$validator.validate()
        return false
      }
    },
    cleanOtherId () {
      switch (this.dniOrPass) {
        case 'dni':
          this.passport = ''
          break
        case 'passport':
          this.dni = ''
          break
      }
    },
    verifyEmailCode () {
      this.validationErrorMsg = ''
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(VerifyCode),
        variables: {
          email: this.email,
          code: this.emailNumberVerification
        }
      }).then((res) => {
        if (res.data.data.validateVerificationCode.success) {
          this.emailNotVerified = ''
          this.verified = true
          this.activePopup = false
        } else {
          this.verificationErrorMsg = 'Código incorrecto'
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    color () {
      return this.verified ? 'success' : 'primary'
    },
    verifyBtn () {
      if (!this.verified) {
        this.activePopup = true
      }
      if (!this.sent) {
        this.sendCode()
      }
    },
    sendCode () {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(SendVerificationCode),
        variables: {
          email: this.email
        }
      }).then((res) => {
        this.sent = true
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  computed: {
    firstname: {
      get () {
        return this.$store.state.SignUp.admin.firstname
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'firstname', data: 'admin', value: val })
      }
    },
    lastname: {
      get () {
        return this.$store.state.SignUp.admin.lastname
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'lastname', data: 'admin', value: val })
      }
    },
    email: {
      get () {
        return this.$store.state.SignUp.admin.email
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'email', data: 'admin', value: val })
      }
    },
    phone: {
      get () {
        return this.$store.state.SignUp.admin.phone
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'phone', data: 'admin', value: val })
      }
    },
    cuil: {
      get () {
        return this.$store.state.SignUp.admin.cuil
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'cuil', data: 'admin', value: val })
      }
    },
    dni: {
      get () {
        return this.$store.state.SignUp.admin.dni
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'dni', data: 'admin', value: val })
      }
    },
    password: {
      get () {
        return this.$store.state.SignUp.admin.password
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'password', data: 'admin', value: val })
      }
    },
    passwordConfirmation: {
      get () {
        return this.$store.state.SignUp.admin.passwordConfirmation
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'passwordConfirmation', data: 'admin', value: val })
      }
    }
  },
  data () {
    return {
      activePopup: false,
      verifyNumber: '12345',
      emailNumberVerification: '',
      verificationErrorMsg: false,
      emailNotVerified: '',
      sent: false,
      verified: false,
      dniOrPass: 'dni',
      passport: '',
      validDniCuil: true
    }
  }
}
</script>
